module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-head"
  }, [_c('a', {
    staticClass: "head-logo",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "logo-100",
    attrs: {
      "src": require("../assets/logo-s.png"),
      "alt": ""
    },
    on: {
      "click": _vm.gohome
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "head-menus-div"
  }, [_c('div', {
    staticClass: "head-menus"
  }, [(['/down', '/'].indexOf(_vm.path) > -1) ? _c('div', {
    staticClass: "menu-2 menu-index"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, [_c('router-link', {
    key: "o1",
    staticClass: "menu-one",
    class: {
      'active-menu-one': _vm.path === '/home'
    },
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("工作台")]), _vm._v(" "), _c('router-link', {
    key: "o2",
    staticClass: "menu-one",
    class: {
      'active-menu-one': _vm.path === '/down'
    },
    attrs: {
      "to": "/down"
    }
  }, [_vm._v("资料库")]), _vm._v(" "), _c('a', {
    key: "o3",
    staticClass: "menu-one",
    class: {
      'active-menu-one': _vm.active_menu_index === 2
    },
    attrs: {
      "href": "http://www.reemii.cn"
    },
    on: {
      "click": function($event) {
        _vm.chooseMenuIndex(2)
      }
    }
  }, [_vm._v("\n            关于我们\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.path.indexOf('/home/cycle') > -1) ? [(_vm.solutionStatus > 10 || _vm.solutionStatus === 10) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'left'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('left')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.left_menus), function(menu, index) {
    return (_vm.solutionStatus > menu.minStatus || _vm.solutionStatus === menu.minStatus) ? _c('a', {
      key: "index",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.solutionStatus > 30 || _vm.solutionStatus === 30) ? _c('div', {
    staticClass: "fg-line"
  }) : _vm._e(), _vm._v(" "), (_vm.solutionStatus > 30 || _vm.solutionStatus === 30) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'right'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('right')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shuju"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.right_menus), function(menu, index) {
    return (_vm.solutionStatus > menu.minStatus || _vm.solutionStatus === menu.minStatus) ? _c('a', {
      key: "index + '-right'",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1)] : _vm._e(), _vm._v(" "), (_vm.path.indexOf('/home/single') > -1) ? [(_vm.preStatus > 10 || _vm.preStatus === 10) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'left'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('left')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.left_menus_p), function(menu, index) {
    return (_vm.preStatus > menu.minStatus || _vm.preStatus === menu.minStatus) ? _c('a', {
      key: "index",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.preStatus > 30 || _vm.preStatus === 30) ? _c('div', {
    staticClass: "fg-line"
  }) : _vm._e(), _vm._v(" "), (_vm.preStatus > 30 || _vm.preStatus === 30) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'right'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('right')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shuju"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.right_menus_p), function(menu, index) {
    return (_vm.preStatus > menu.minStatus || _vm.preStatus === menu.minStatus) ? _c('a', {
      key: "index + '-right'",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1)] : _vm._e(), _vm._v(" "), (_vm.path.indexOf('/single_home/single') > -1) ? [(_vm.preStatus > 10 || _vm.preStatus === 10) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'left'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('left')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.left_menus_ps), function(menu, index) {
    return (_vm.preStatus > menu.minStatus || _vm.preStatus === menu.minStatus) ? _c('a', {
      key: "index",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.preStatus > 30 || _vm.preStatus === 30) ? _c('div', {
    staticClass: "fg-line"
  }) : _vm._e(), _vm._v(" "), (_vm.preStatus > 30 || _vm.preStatus === 30) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'right'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('right')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shuju"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.right_menus_ps), function(menu, index) {
    return (_vm.preStatus > menu.minStatus || _vm.preStatus === menu.minStatus) ? _c('a', {
      key: "index + '-right'",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1)] : _vm._e()], 2)]), _vm._v(" "), (_vm.path.indexOf('/single_home/single') > -1) ? [_c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "head-btn-a",
    on: {
      "click": _vm.goOther
    }
  }, [_vm._v(_vm._s(_vm.path.indexOf('adjust_home') ? '配单' : '流程'))])])]), _vm._v(" "), _c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info qh-btn"
  }, [_c('span', {
    staticClass: "head-btn-a"
  }, [_vm._v(_vm._s(_vm.getLabel(_vm.oilArea)))]), _vm._v(" "), (_vm.pszxDatas.length > 0) ? _c('div', {
    staticClass: "choose-ps"
  }, _vm._l((_vm.pszxDatas), function(item) {
    return _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.oilArea = item.key
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  })) : _vm._e()])])] : _vm._e(), _vm._v(" "), [(_vm.path.indexOf('oil_chart') === -1 && _vm.path.indexOf('gas_map') === -1) ? _c('user-info') : _vm._e()], _vm._v(" "), (!_vm.noLogin) ? [(_vm.path.indexOf('oil_chart') > -1 || _vm.path.indexOf('gas_map') > -1) ? _c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goHaveFun
    }
  }, [_vm._v("Have Fun")])])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.path) + "\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-480bb290","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHead.vue
// module id = 978
// module chunks = 1